import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { IInteriorMaterial2, InteriorMaterialClient, InteriorMaterialTranslation, SetInteriorMaterialDetailsRequest } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { State, useState2 } from '../../../util/useState2';
import { ImageSetter } from '../MaterialEditor/ImageSetter';

export function SingleInteriorMaterialEditor(props: {
    material: IInteriorMaterial2,
    selectedTranslationIndex: State<number>
    onChange: () => void,
}) {


    const tc = useContext(TranslationContext);
    const client = useClient(InteriorMaterialClient);
    const translations = useState2(() => props.material.translations.map(t => ({
        id: t.languageId,
        languageName: t.languageName,
        name: t.name,
        isChanged: false
    })));
    const selectedTranslationIndex = props.selectedTranslationIndex;
    const selectedTranslation = translations.value[selectedTranslationIndex.value];


    async function commit(evt: React.FormEvent) {
        evt.preventDefault();
        try {
            await client.setDetails(props.material.id, new SetInteriorMaterialDetailsRequest({
                translations: translations.value.filter(n => n.isChanged).map(n => new InteriorMaterialTranslation({
                    languageId: n.id,
                    languageName: "",
                    name: n.name
                })),
            }));
        }
        finally {
            props.onChange();
        }
    }

    async function setImage(f: File) {
        try {
            const extension = f.type.split("/")[1];
            await client.setSampleImage(props.material.id, extension, {
                data: f,
                fileName: f.name
            });

        }
        finally {
            props.onChange();
        }
    }
    function setLanguage(index: number) {
        selectedTranslationIndex.set(index);
    }
    function setName(name: string) {
        const newTranslations = [...translations.value];
        newTranslations[selectedTranslationIndex.value] = {
            ...selectedTranslation,
            name: name,
            isChanged: true
        };
        translations.set(newTranslations);
    }

    return (
        <div className="single-interior-material-editor">
            <h2>
                {tc.translator("admin edit interior material header", "Rediger interiør-materiale {name}", {
                    name: props.material.defaultName
                })}
            </h2>

            <form onSubmit={commit}>
                <div className="form-group">
                    <label htmlFor="material-name">
                        {tc.translator("admin edit interior material language", "Sprog")}
                    </label>
                    <select value={selectedTranslationIndex.value}
                        onChange={evt => setLanguage(parseInt(evt.target.value))}
                        id="material-name"
                        className="form-control"
                    >
                        {translations.value.map((t, index) => (
                            <option key={index} value={index}>
                                {t.languageName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="material-name">
                        {tc.translator("admin edit interior material name", "Navn")}
                    </label>
                    <div className="input-group">
                        <input type="text"
                            className="form-control"
                            id="material-name"
                            value={selectedTranslation.name}
                            onChange={evt => setName(evt.target.value)}
                        />
                    </div>
                </div>

                <button type="submit" className="btn btn-primary">
                    {tc.translator("admin edit interior material save button", "Gem")}
                </button>

            </form>
            <div className="spacer" style={{ marginTop: "20px" }}>

            </div>
            <Card>
                <Card.Body>
                    <Card.Title>
                        {tc.translator("admin edit interior material", "Billede")}
                    </Card.Title>
                    <Card.Body>
                        <ImageSetter url={props.material.sampleImageUrl}
                            onSet={setImage}
                        />
                    </Card.Body>
                </Card.Body>
            </Card>
        </div>
    );
}
